// DS: i3.30
import React from 'react';
import IconWrap from '../../IconWrap';
const ChangeSkin = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.0003 2.6666c7.3627 0 13.3334 5.304 13.3334 11.852a7.411 7.411 0 0 1-7.408 7.4067h-2.6214c-1.2293 0-2.2226.9933-2.2226 2.2227 0 .5626.2226 1.0813.5626 1.4666.356.4.5787.9187.5787 1.496 0 1.2307-1.0227 2.2227-2.2227 2.2227C8.6377 29.3333 2.667 23.3626 2.667 16c0-7.3627 5.9707-13.3334 13.3333-13.3334ZM14.415 24.148a4.886 4.886 0 0 1 3.0176-4.5183 4.8867 4.8867 0 0 1 1.8717-.3711h2.6214A4.7442 4.7442 0 0 0 26.667 14.52c0-5.0014-4.7093-9.1867-10.6667-9.1867a10.6667 10.6667 0 0 0-.9013 21.296 4.8684 4.8684 0 0 1-.684-2.4813ZM10.0003 16a2.0003 2.0003 0 0 1-2-2 2.0001 2.0001 0 0 1 3.4142-1.4143A2 2 0 0 1 10.0003 16Zm12 0a2.0004 2.0004 0 0 1-2-2 2 2 0 1 1 2 2Zm-6-4a2.0004 2.0004 0 0 1-2-2 1.9999 1.9999 0 1 1 2 2Z",
        fill: "currentColor"
    })));
};
ChangeSkin.displayName = 'ChangeSkin';
export default ChangeSkin;

//# sourceMappingURL=ChangeSkin.js.map